import { Eye } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Persistent gold strip shown while a true platform admin is browsing
 * the app in "View as customer" mode. Always visible at the very top
 * of the app shell so the admin can't forget they're hiding their own
 * admin affordances.
 */
export const CustomerViewBanner = () => {
  const { isTruePlatformAdmin, viewAsCustomer, setViewAsCustomer } = useAuth();

  if (!isTruePlatformAdmin || !viewAsCustomer) return null;

  return (
    <div
      className="bg-amber-400 text-[#070d1c] shadow-sm -mx-8 -mt-8 mb-6"
      role="status"
      data-testid="customer-view-banner"
    >
      <div className="px-8 py-2 flex items-center justify-between gap-4 text-sm">
        <div className="flex items-center gap-2 font-medium">
          <Eye className="h-4 w-4" />
          <span>
            Viewing as customer — internal admin features are hidden.
          </span>
        </div>
        <button
          type="button"
          onClick={() => setViewAsCustomer(false)}
          className="inline-flex items-center gap-1 px-3 py-1 rounded-md bg-[#070d1c] text-amber-300 hover:bg-[#0c1530] transition-colors text-xs font-semibold"
          data-testid="exit-customer-view-btn"
        >
          Exit customer view
        </button>
      </div>
    </div>
  );
};

export default CustomerViewBanner;
